module.exports = __webpack_public_path__ + "img/Logo-Latino-Seguros_Mesa.aedba87f.png";